export const playPausePositionMap = {
  top: "top-0",
  default: "top-1/2 -translate-y-1/2",
  bottom: "bottom-0",
};

export type PlayPausePosition = keyof typeof playPausePositionMap;
